import { memo } from 'react';
import { HStack, Stack, Text } from '@adc/parallax-component-library';
import {
  IconValidationInvalid,
  IconValidationNotValidated,
  IconValidationValid,
} from '@adc/parallax-icons';
import i18n from 'Utilities/i18n';

type Props = {
  requirements: Requirement[];
};

const PasswordRequirements = memo(({ requirements }: Props) => (
  <Stack>
    {requirements.map(({ isInvalid, match, data }) => {
      return (
        <HStack alignItems="center" key={data.key}>
          {isInvalid ? (
            <IconValidationInvalid color="$support.danger.surfaceOnColorAlt" />
          ) : match ? (
            <IconValidationValid color="$support.positive.default" />
          ) : (
            <IconValidationNotValidated color="$neutral.40" />
          )}
          <Text
            marginLeft="$2"
            testID={`Login.content.signInForm.formField.password.helpText.${data.key}`}
            color={isInvalid ? '$support.danger.surfaceOnColorAlt' : '$neutral.60'}
            type="$bodySmall.default"
          >
            {i18n.t(
              // @ts-expect-error FIXME: need more predictable typing
              `Login.content.signInForm.formField.password.helpText.${data.key}`,
              { count: data.value }
            )}
          </Text>
        </HStack>
      );
    })}
  </Stack>
));

PasswordRequirements.displayName = 'PasswordRequirements';

export { PasswordRequirements };
